import React, { useEffect, useState } from 'react';

import { Routes, Route, Link, Navigate, useLocation } from "react-router-dom";

import './App.css';
import About from './components/About/About';
import Contact from './components/Contact/Contact';
import Home from './components/Home/Home';
import LancelyComponent from './components/Portfolio/LancelyComponent';
import Portfolio from './components/Portfolio/Portfolio';
import Resume from './components/Resume/Resume';
import Services from './components/Services/Services';

const navigationItems = [
  { to: '/', label: 'Home' },
  { to: '/about', label: 'About' },
  { to: '/resume', label: 'Resume' },
  { to: '/portfolio', label: 'Portfolio' },
  { to: '/services', label: 'Services' },
  { to: '/contact', label: 'Contact' },
];

const socialLinks = [
  { href: 'https://www.linkedin.com/in/omarquazi', label: 'LinkedIn', icon: 'fab fa-linkedin' },
  { href: 'https://github.com/blacksector', label: 'GitHub', icon: 'fab fa-github' },
  { href: 'https://twitter.com/omarquazi', label: 'Twitter', icon: 'fab fa-twitter' },
  { href: 'https://instagram.com/omarquazi', label: 'Instagram', icon: 'fab fa-instagram' },
];

function App() {

  const location = useLocation();
  const [isNavOpen, setIsNavOpen] = useState(false);
  const isNavigationItemActive = (item) => item.to === '/'
    ? location.pathname === '/'
    : location.pathname === item.to || location.pathname.startsWith(`${item.to}/`);

  useEffect(() => {
    setIsNavOpen(false);
  }, [location.pathname]);

  useEffect(() => {
    if (location.state?.preserveScroll) {
      return;
    }

    const prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    const scrollOptions = {
      top: 0,
      left: 0,
      behavior: prefersReducedMotion ? 'auto' : 'smooth'
    };
    const content = document.getElementById('content');

    window.scrollTo(scrollOptions);
    content?.scrollTo(scrollOptions);
  }, [location.pathname, location.state]);

  useEffect(() => {
    const loader = document.querySelector(".loader");

    if (!loader) {
      return undefined;
    }

    loader.style.display = "none";

    return undefined;
  }, [])


  return (
    <>
      <a className="skip-link" href="#main-content">Skip to content</a>
      <div className="loader">
        <div className="la-ball-grid-pulse la-dark la-2x">
          <div></div>
          <div></div>
          <div></div>
          <div></div>
          <div></div>
          <div></div>
          <div></div>
          <div></div>
        </div>
      </div>

      <nav id="mobileNav" className={isNavOpen ? 'fadeIn' : ''} aria-label="Primary navigation" aria-hidden={!isNavOpen} inert={isNavOpen ? undefined : ''}>
        <button className="close" type="button" onClick={() => setIsNavOpen(false)} aria-label="Close navigation">
          &#x2573;
        </button>
        <div className="mobileNavigation">
          <div className="lead">
            Navigation
          </div>
          <ul>
            {navigationItems.map((item) => (
              <li key={item.to} className={isNavigationItemActive(item) ? 'active' : ''}>
                <Link to={item.to}>{item.label}</Link>
              </li>
            ))}
            <li>
              <ul className="mobile-social-nav">
                {socialLinks.map((socialLink) => (
                  <li key={socialLink.href}>
                    <a className="nav-link" href={socialLink.href} target="_blank" rel="noreferrer" aria-label={socialLink.label}>
                      <i className={socialLink.icon} aria-hidden="true"></i>
                    </a>
                  </li>
                ))}
              </ul>
            </li>
          </ul>
        </div>
      </nav>

      <div id="content" className={`transformToLeft ${isNavOpen ? '' : 'hidden'}`}>
        <header>
          <button className={`mobile-toggler ${location.pathname !== '/' ? 'mobile-toggler-other' : ''}`} type="button" onClick={() => setIsNavOpen(true)} aria-expanded={isNavOpen} aria-controls="mobileNav">
            MENU <span>&#9776;</span>
          </button>
        </header>

        <main id="main-content" className={location.pathname !== '/' ? 'lighter-background' : ''}>
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/about" element={<About />} />
            <Route path="/resume" element={<Resume />} />
            <Route path="/portfolio" element={<Portfolio />} />
            <Route path="/lancely" element={<Navigate to="/portfolio/lancely" replace />} />
            <Route path="/portfolio/lancely" element={<LancelyComponent />}/>
            <Route path="/portfolio/:projectId" element={<Portfolio />} />
            <Route path="/services" element={<Services />} />
            <Route path="/contact" element={<Contact />} />
          </Routes>
        </main>
      </div>
    </>
  );
}

export default App;
